import { urlFor } from "./sanityClient";

export const FALLBACK_BLOG_IMAGE = "/assets/images/services/bookkeeping.jpg";

export const hasImageAsset = (image) =>
  Boolean(image?.asset?._ref || image?.asset?._id);

export const buildImageUrl = (image, transform) => {
  if (!hasImageAsset(image)) return null;

  try {
    const builder = urlFor(image);
    if (!builder) return null;
    return transform(builder).url() || null;
  } catch {
    return null;
  }
};

export const getPostImageUrl = (post, { width = 800, height = 450 } = {}) =>
  buildImageUrl(post?.mainImage, (builder) =>
    builder.width(width).height(height).fit("crop")
  ) || FALLBACK_BLOG_IMAGE;
